import axios, { CancelTokenSource } from 'axios';
import {
  BookingConfig,
  BookingConfigEnum,
} from '../../components/BookingWidget/bookingSteps.interface';
import { BookingStepsContextState } from '../../context/bookingContext/bookingContext.types';
import { BookingDataResponse } from '../../components/BookingWidget/BookingManagment/bookingManagment.interface';
import preparePricingPayload from '../../components/QuotationSummaryBlock/preparePricingPayload';
import { CreatePriceResponse } from '../interfaces/plugAndSell/createPricingResponse';

export interface GetPricingParams {
  bookingSteps: BookingStepsContextState;
  bookingConfigData: BookingConfig;
  bookingDataResponse: BookingDataResponse | null;
  includeCatalogVersion?: boolean;
  cancelToken?: CancelTokenSource;
}

async function getPricing(
  params: GetPricingParams,
): Promise<CreatePriceResponse> {
  const {
    bookingSteps,
    bookingConfigData,
    bookingDataResponse,
    includeCatalogVersion = true,
    cancelToken,
  } = params;

  const apiCM360Url =
    bookingConfigData[BookingConfigEnum.DataCenter].cm360Endpoint;
  const clientId = bookingConfigData[BookingConfigEnum.DataCenter].psClient;
  const url = `${apiCM360Url}/ui-proxy/ws-partners/api/platforms/${bookingConfigData.dataCenter.psPlatform}/catalogs/${bookingSteps.quotationForm.tripDetails.value}/pricing`;

  const payload = preparePricingPayload(
    bookingSteps,
    bookingConfigData,
    bookingDataResponse,
    includeCatalogVersion,
  );

  const response = await axios.post<CreatePriceResponse>(url, payload, {
    headers: { 'Client-Id': clientId },
    cancelToken: cancelToken?.token,
  });

  return response.data;
}

export function createCancelTokenSource(): CancelTokenSource {
  return axios.CancelToken.source();
}

export function isRequestCancelled(error: any): boolean {
  return axios.isCancel(error);
}

export default getPricing;
